/*
LUCID LOOM — STEP 81
Premium Header Bootstrap: Core-JS + Full-CSS werden auf der Live-Homepage
erst vor der ersten echten Header-Interaktion aktiviert.

- Desktop erhält die bestehende Full-CSS bereits über das Head-Media-Stylesheet.
- Mobile startet nur mit ll-premium-header-mobile-critical.css.
- Vor Drawer/Search/Localization/Cart-Interaktion wird die unveränderte
  ll-premium-header.css aktiviert und danach die bestehende Core-JS geladen.
- Alle Nicht-Homepage-Seiten behalten die bisherige Full-CSS-Architektur.
*/
(function(){
'use strict';

if(window.__LL_PREMIUM_HEADER_BOOTSTRAP_V81) return;
window.__LL_PREMIUM_HEADER_BOOTSTRAP_V81=true;

var scriptEl=document.currentScript;
var coreSrc=scriptEl && scriptEl.dataset
  ? scriptEl.dataset.llPremiumHeaderCore || ''
  : '';
var cssSrc=scriptEl && scriptEl.dataset
  ? scriptEl.dataset.llPremiumHeaderCss || ''
  : '';

var corePromise=null;
var cssPromise=null;
var coreReady=!!window.__LL_PREMIUM_HEADER_CORE_V51;

function findFullCssLink(){
  return document.querySelector('link[data-ll-premium-header-full-css]') ||
    (cssSrc ? document.querySelector('link[href="'+cssSrc.replace(/"/g,'\\"')+'"]') : null);
}

function loadFullCss(){
  if(!cssSrc) return Promise.resolve();
  if(cssPromise) return cssPromise;

  cssPromise=new Promise(function(resolve,reject){
    var link=findFullCssLink();

    function ready(){ resolve(link); }
    function fail(err){ cssPromise=null; reject(err); }

    if(link){
      /* On mobile the head link starts as min-width:1000px. Activating it here
         makes the original full stylesheet the final cascade before replay. */
      if(link.media!=='all') link.media='all';
      if(link.sheet){
        resolve(link);
        return;
      }
      link.addEventListener('load',ready,{once:true});
      link.addEventListener('error',fail,{once:true});
      return;
    }

    link=document.createElement('link');
    link.rel='stylesheet';
    link.href=cssSrc;
    link.media='all';
    link.dataset.llPremiumHeaderFullCss='true';
    link.addEventListener('load',ready,{once:true});
    link.addEventListener('error',fail,{once:true});
    document.head.appendChild(link);
  });

  return cssPromise;
}

function loadCoreScript(){
  if(coreReady || window.__LL_PREMIUM_HEADER_CORE_V51){
    coreReady=true;
    return Promise.resolve();
  }
  if(corePromise) return corePromise;

  corePromise=new Promise(function(resolve,reject){
    if(!coreSrc){
      reject(new Error('Missing LL Premium Header core URL'));
      return;
    }

    var existing=document.querySelector('script[data-ll-premium-header-core-script]');
    if(existing){
      if(window.__LL_PREMIUM_HEADER_CORE_V51){
        coreReady=true;
        resolve();
        return;
      }
      existing.addEventListener('load',function(){
        coreReady=true;
        resolve();
      },{once:true});
      existing.addEventListener('error',reject,{once:true});
      return;
    }

    var s=document.createElement('script');
    s.src=coreSrc;
    s.async=true;
    s.fetchPriority='low';
    s.dataset.llPremiumHeaderCoreScript='true';

    s.addEventListener('load',function(){
      coreReady=true;
      resolve();
    },{once:true});
    s.addEventListener('error',function(err){
      corePromise=null;
      reject(err);
    },{once:true});
    document.head.appendChild(s);
  });

  return corePromise;
}

function loadCore(){
  return Promise.all([loadFullCss(),loadCoreScript()]);
}

window.LLPremiumHeaderLoadFullCss=loadFullCss;
window.LLPremiumHeaderLoadCore=loadCore;

var header=document.querySelector('.ll-premium-header');
if(!header) return;

var warmSelector=[
  '.ll-mobile-toggle',
  '.ll-drawer-close',
  '.ll-search-toggle',
  '.ll-mini-search-close',
  '.ll-cart-toggle',
  '.ll-drawer-sub-toggle',
  '.ll-drawer-grand-toggle',
  '[data-language-toggle]',
  '[data-country-toggle]',
  '.ll-drawer-localization-toggle',
  '.ll-whatsapp-direct-link',
  '[data-mobile-language]',
  '[data-mobile-country]',
  '[data-locale]',
  '[data-country]',
  '[data-ll-predictive-input]',
  '.ll-drawer-search input'
].join(',');

var cssWarmSelector=[
  '.ll-menu-item.has-dropdown',
  '.ll-localization-wrapper',
  '.ll-search-wrapper'
].join(',');

var replaySelector=[
  '.ll-mobile-toggle',
  '.ll-drawer-close',
  '.ll-search-toggle',
  '.ll-mini-search-close',
  '.ll-cart-toggle__hitbox',
  '.ll-drawer-sub-toggle',
  '.ll-drawer-grand-toggle',
  '[data-language-toggle]',
  '[data-country-toggle]',
  '.ll-drawer-localization-toggle',
  '.ll-whatsapp-direct-link',
  '[data-mobile-language]',
  '[data-mobile-country]',
  '[data-locale]',
  '[data-country]'
].join(',');

function closestWithin(target,selector){
  if(!target || !target.closest) return null;
  var match=target.closest(selector);
  return match && header.contains(match) ? match : null;
}

/* CSS-only desktop surfaces warm the original stylesheet without waking the
   heavier core script. */
header.addEventListener('pointerover',function(e){
  if(closestWithin(e.target,cssWarmSelector)) loadFullCss().catch(function(){});
  if(closestWithin(e.target,warmSelector)) loadCore().catch(function(){});
},{passive:true,capture:true});

header.addEventListener('pointerdown',function(e){
  if(closestWithin(e.target,cssWarmSelector)) loadFullCss().catch(function(){});
  if(closestWithin(e.target,warmSelector)) loadCore().catch(function(){});
},{passive:true,capture:true});

header.addEventListener('focusin',function(e){
  if(closestWithin(e.target,cssWarmSelector)) loadFullCss().catch(function(){});
  if(closestWithin(e.target,warmSelector)) loadCore().catch(function(){});
},true);

/* First-tap safety: the exact interaction is replayed only after BOTH the
   original full CSS and the existing Core-JS are ready. */
header.addEventListener('click',function(e){
  if(coreReady || window.__LL_PREMIUM_HEADER_CORE_V51) return;

  var replayTarget=closestWithin(e.target,replaySelector);
  if(!replayTarget) return;

  e.preventDefault();
  e.stopPropagation();
  if(typeof e.stopImmediatePropagation==='function') e.stopImmediatePropagation();

  loadCore()
    .then(function(){
      requestAnimationFrame(function(){
        if(replayTarget && replayTarget.isConnected && typeof replayTarget.click==='function'){
          replayTarget.click();
        }
      });
    })
    .catch(function(){});
},true);

header.addEventListener('keydown',function(e){
  if(coreReady || window.__LL_PREMIUM_HEADER_CORE_V51) return;
  if(e.key==='Enter' || e.key===' ' || e.key==='Escape'){
    if(closestWithin(e.target,warmSelector)) loadCore().catch(function(){});
    else if(closestWithin(e.target,cssWarmSelector)) loadFullCss().catch(function(){});
  }
},true);

[
  'cart:open',
  'cart-drawer:open',
  'cart:toggle',
  'cart:change',
  'cart:refresh',
  'cart-drawer:rendered'
].forEach(function(eventName){
  document.addEventListener(eventName,function(){
    loadCore().catch(function(){});
  },{passive:true});
});

document.addEventListener('shopify:section:load',function(event){
  if(event && event.target && event.target.querySelector &&
     event.target.querySelector('.ll-premium-header')){
    loadCore().catch(function(){});
  }
});

document.addEventListener('ll:premium-header-core-ready',function(){
  coreReady=true;
},{once:true});
})();
